/**
 * ReservationCountdownBadge — Iter 309
 *
 * Zeigt einen Live-Countdown ("läuft ab in 2h 47min") auf einem
 * Chatbot-Slot-Reservation-Termin im Admin-Kalender. Updatet sich
 * jede 30 Sekunden, damit der Trainer/Admin live sieht wie viel
 * Zeit der Kunde noch hat zum Bestätigen.
 */
import React, { useEffect, useState } from 'react';

const formatRemaining = (msRemaining) => {
  if (msRemaining <= 0) return 'abgelaufen';
  const totalMin = Math.floor(msRemaining / 60000);
  const h = Math.floor(totalMin / 60);
  const m = totalMin % 60;
  if (h >= 1) return `${h}h ${m}min`;
  return `${m} min`;
};

const ReservationCountdownBadge = ({ expiresAt }) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 30000);
    return () => clearInterval(interval);
  }, []);

  const expires = new Date(expiresAt).getTime();
  const remaining = expires - now;
  const isExpired = remaining <= 0;

  return (
    <div
      className="absolute inset-x-0 top-0 bg-amber-700 text-white text-[10px] font-bold uppercase tracking-wide text-center py-0.5 shadow-sm pointer-events-none"
      style={{ zIndex: 11 }}
      data-testid="reservation-badge"
    >
      {isExpired ? '⌛ ABGELAUFEN' : `🔒 RESERVIERT · ${formatRemaining(remaining)}`}
    </div>
  );
};

export default ReservationCountdownBadge;
